/** 订单用户列表 status：1 未支付 2 已支付 3 已完成 4 已退款 5 部分退款 */
export function getOrderUserStatusBadgeClass(status: number | undefined): string {
  if (status == null || Number.isNaN(Number(status))) {
    return "text-[rgba(71,84,103,1)] bg-[rgba(242,244,247,1)]";
  }
  const n = Number(status);
  switch (n) {
    case 1:
      return "text-[rgba(180,83,9,1)] bg-[rgba(254,252,232,1)]";
    case 2:
      return "text-[rgba(29,78,216,1)] bg-[rgba(239,246,255,1)]";
    case 3:
      return "text-[rgba(6,118,71,1)] bg-[rgba(236,253,243,1)]";
    case 4:
      return "text-[rgba(71,84,103,1)] bg-[rgba(242,244,247,1)]";
    case 5:
      return "text-[rgba(122,46,14,1)] bg-[rgba(255,247,237,1)]";
    default:
      return "text-[rgba(71,84,103,1)] bg-[rgba(242,244,247,1)]";
  }
}